import React from 'react';

import AcademyIaTable from '../Table';

import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AcademyIaTable />
    </div>
  );
};
